import React from 'react';
import DataTables from '../../CommonDataTable/DataTable';
import config from '../../../../config/config';
import apiCalls from '../../../../config/apiCalls'
import store from '../../../App/store';
import RolePermissions from '../../CommonModals/Permissions';
import ViewModal from '../../CommonModals/viewModal';

// config file
export default class Activities extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			type: 'Activities',
			rolePermission: "",
			viewSelectedRecord:window.location.href.includes("view")
		};
	}

	static getDerivedStateFromProps(props, state) {
		let storeData = store.getState()
		let languageData = storeData && storeData.settingsData && storeData.settingsData.settings && storeData.settingsData.settings.languageTranslation ? storeData.settingsData.settings.languageTranslation : ""
		return { languageData: languageData };
	}

	componentDidMount = () => {
		//Screen permisions value can be edit,view, no view
		let screenPermissions = RolePermissions.screenPermissions('Activities');
		if (screenPermissions) {
			this.setState({
				rolePermission: screenPermissions
			})
		}
	}

	getTableFields = () => {
		let { languageData } = this.state
		let data =
			[
				{
					textAlign: "center",
					width: 47,
					field: "Sno",
					header: "Sno",
					label: "Sno",
					filter: false,
					sortable: false,
					mobile: true,
					placeholder: "Search",
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "center",
					show: true,
					mobile: true,
					width: "160px",
					field: "created",
					label: "Created",
					fieldType: "Date",
					type:'date',
					dateFormat: config.fullDateFormat,
					header: "Created Date",
					filter: true,
					sortable: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "150px",
					field: "context",
					mobile: true,
					header: "Context",
					label: "Context",
					filter: true,
					sortable: true,
					show: true,
					textCapitalize: true,
					displayInSettings: true,
					fieldType: "Link"
				},
				{
					textAlign: "left",
					width: "150px",
					field: "contextType",
					mobile: true,
					label: "Context Type",
					header: "Context Type",
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "200px",
					field: "email",
					mobile: true,
					label: "Email",
					header: "Email",
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "150px",
					field: "contextId",
					mobile: true,
					header: "Record Name",
					label: "Record Name",
					filter: true,
					sortable: true,
					show: true,
					textCapitalize: true,
					displayInSettings: true,
					searchField:"name",
					fieldType: "relateAutoComplete",
					
				},
				{
					show: true,
					textAlign: "left",
					width: "250px",
					mobile: true,
					field: "description",
					header: "Description",
					filter: true,
					label: "Description",
					sortable: true,
					textCapitalize: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "150px",
					field: "ipAddress",
					label: "Ip Address",
					mobile: true,
					header: 'Ip Address',
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "110px",
					field: "deviceType",
					label: "Device Type",
					mobile: true,
					header: 'Device Type',
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "130px",
					field: "browserName",
					label: "Browser Name",
					mobile: true,
					header: 'Browser Name',
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "110px",
					field: 'osName',
					label: "Os Name",
					mobile: true,
					header: 'Os Name',
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "90px",
					field: 'osVersion',
					label: "Os Version",
					mobile: true,
					header: 'Os Version',
					filter: false,
					sortable: true,
					show: true,
					displayInSettings: true,
				},			]
		return data;
	};

	getFormFields = () => {
		let { languageData } = this.state
		let data =
			[
				
				{
					textAlign: "center",
					show: true,
					mobile: true,
					width: "160px",
					field: "created",
					label: "Created",
					fieldType: "Date",
					type:'date',
					dateFormat: config.fullDateFormat,
					header: "Created Date",
					filter: true,
					sortable: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "150px",
					field: "context",
					mobile: true,
					header: "Context",
					label: "Context",
					filter: true,
					sortable: true,
					show: true,
					textCapitalize: true,
					displayInSettings: true,
					fieldType: "Link"
				},
				{
					textAlign: "left",
					width: "150px",
					field: "contextType",
					mobile: true,
					label: "Context Type",
					header: "Context Type",
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "200px",
					field: "email",
					mobile: true,
					label: "Email",
					header: "Email",
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},				
				{
					textAlign: "left",
					width: "110px",
					field: "ipAddress",
					label: "Ip Address",
					mobile: true,
					header: 'Ip Address',
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "110px",
					field: "deviceType",
					label: "Device Type",
					mobile: true,
					header: 'Device Type',
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "130px",
					field: "browserName",
					label: "Browser Name",
					mobile: true,
					header: 'Browser Name',
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "150px",
					field: 'osName',
					label: "Os Name",
					mobile: true,
					header: 'Os Name',
					filter: true,
					sortable: true,
					show: true,
					displayInSettings: true,
				},
				{
					textAlign: "left",
					width: "130px",
					field: 'osVersion',
					label: "Os Version",
					mobile: true,
					header: 'Os Version',
					filter: false,
					sortable: true,
					show: true,
					displayInSettings: true,
				},	
				{
					show: true,
					textAlign: "left",
					width: "250px",
					mobile: true,
					field: "description",
					header: "Description",
					filter: true,
					label: "Description",
					sortable: true,
					textCapitalize: true,
					displayInSettings: true,
				}		
			]
		return data;
	};

	setData = (props) => {
		let rowData = {}
		console.log(props.match);
		if (props && props.match && props.match.params && props.match.params.id) {
			rowData["_id"] = JSON.parse(props.match.params.id)
			return rowData
		}
	}




	render() {
		return (
			<span>
				<DataTables
					{...this.props}
					getTableFields={this.getTableFields}
					formFields={this.getFormFields}
					actionsTypes={[
					// 	{
					// 	'name': 'Delete',
					// 	"options": [
					// 		{ 'label': 'Delete', 'value': 'Delete', 'show': this.state.rolePermission && this.state.rolePermission == "Edit" ? true : false, "multiple": true, },
					// 	]
					// },
					]}
					setData={this.setData}
					exportRequried={false}
					printRequried={false}
					addRequried={false}
					editRequired={false}
					deleteRequired={false}
					viewRequired={true}
					settingsRequired={true}
					filterRequired={false}
					gridRequried={false}
					sample={false}
					globalSearchFieldName='activity'
					globalSearch={"Context/Email/Description"}					
					type="Activities"
					apiResponseKey={"activities"}
					apiUrl={"activities"}
					routeTo='activities'
					displayViewOfForm='modal'
					viewSelectedRecord={this.state.viewSelectedRecord}
				/>
			</span>
		);
	}
}